module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "betting-ball",
    class: {
      is__active: _vm.ball.status
    },
    on: {
      "click": function($event) {
        _vm.selectBall(_vm.ball)
      }
    }
  }, [_c('div', {
    staticClass: "ball-number"
  }, [_vm._v("\n    " + _vm._s(_vm.ball.number) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07928974","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Ball.vue
// module id = 396
// module chunks = 0